import { deploymentsSelector } from "fleet/redux-store/deployments/selectors";
import { DeploymentListPage } from "fleet/view/strategy-v2/deploy-list";
import { connect } from "react-redux";
import { storesReady, makeGetAllAsArray } from "redux-store";

const getAllDeploymentsAsArray = makeGetAllAsArray();

function mapStateToProps(state) {
  const deploymentsById = deploymentsSelector(state);
  const deployments = getAllDeploymentsAsArray({ byId: deploymentsById });
  const storesLoaded = storesReady(state.app.deployments);

  return {
    deployments,
    storesLoaded,
  };
}

const ConnectedDeploymentListPage =
  connect(mapStateToProps)(DeploymentListPage);

export { ConnectedDeploymentListPage };
